import { ContentCard } from '../components';
import { ExperienceData } from '../utils/text-data/experience';
import { TimelineComponent } from '../components/timeline';

export const ExperienceSection = () => {
  return (
    <ContentCard cardTitle={'Experience'} className='gap-4'>
      <TimelineComponent
        dataList={ExperienceData}
        //timelineDot='💻'
        showTotalDuration
      />
    </ContentCard>
  );
};
